import i18n from 'modules/core/lib/i18n'

import type CustomField from 'modules/custom_resources/store/models/customFields/Field'

interface Props {
  title?: string
  description?: string
  addQuestionLabel?: string
  emptyMessage?: string
  illustration?: string
  modalIllustration?: string
  modalTitle?: string
  modalDescription?: string
  modalPlaceholder?: string
  modalLabel?: string
  modalButton?: string
  modalButtonUpdate?: string
  modalAlert?: string
}

export const OptionalParamsProcessor = (props: Props) => {
  const get = (field: string, customField: CustomField | null | undefined): string => {
    switch (field) {
      case 'illustration':
        return props.illustration || 'input-field'

      case 'modalIllustration':
        return props.modalIllustration || 'pencil'

      case 'modalTitle':
        return (
          props.modalTitle ||
          (customField
            ? i18n.t('settings.custom_fields.edit_modal.title')
            : i18n.t('settings.custom_fields.new.title'))
        )

      case 'modalDescription':
        return (
          props.modalDescription ||
          (customField
            ? i18n.t('settings.custom_fields.edit_modal.description')
            : i18n.t('settings.custom_fields.new.description'))
        )

      case 'modalLabel':
        return props.modalLabel || i18n.t('settings.custom_fields.new.labels.title')

      case 'modalPlaceholder':
        return props.modalPlaceholder || ''

      case 'modalButton':
        return props.modalButton || i18n.t('settings.custom_fields.new.submit')

      case 'modalButtonUpdate':
        return props.modalButtonUpdate || i18n.t('settings.custom_fields.edit_modal.submit')

      case 'modalAlert':
        return props.modalAlert || ''

      case 'emptyMessage':
        return props.emptyMessage || i18n.t('settings.custom_fields.blank_slate.description')

      case 'title':
        return props.title || i18n.t('settings.custom_fields.title')

      case 'description':
        return props.description || i18n.t('settings.custom_fields.title')

      case 'addQuestionLabel':
        return props.addQuestionLabel || i18n.t('settings.custom_fields.create')

      default:
        return ''
    }
  }

  return {
    get,
  }
}
